import { PATTERN_SYMBOLS } from './pattern-symbols.mjs';
export const PATTERN_CATALOG=Object.entries(PATTERN_SYMBOLS).map(([name,symbol])=>({
    id:symbol.id,name,kind:symbol.candles?'candlestick':'chart',bias:symbol.bias,symbol,
})).sort((a,b)=>a.kind.localeCompare(b.kind)||a.name.localeCompare(b.name));
export function patternEnabled(name,settings={}){
    const definition=PATTERN_SYMBOLS[name];
    return definition&&settings.patternVisibility?.[definition.id]!==false;
}
